import { MenuItemNested, MenuSlug } from '@core/const';
import { StateUtils } from '@spartacus/core';
import { MENU_NESTED } from '../core-state';

export const LOAD_MENU_NESTED = '[Core] Menu Nested Load';
export const LOAD_MENU_NESTED_SUCCESS = '[Core] Menu Nested Load Success';
export const LOAD_MENU_NESTED_FAIL = '[Core] Menu Nested Load Fail';
export const MENU_NESTED_RESET = '[Core] Menu Nested Reset';

export class MenuNestedLoad extends StateUtils.EntityLoadAction {
  readonly type = LOAD_MENU_NESTED;

  constructor(
    public slug: MenuSlug,
    public baseStoreCode: string,
  ) {
    super(MENU_NESTED, slug);
  }
}

export class MenuNestedLoadFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_MENU_NESTED_FAIL;

  constructor(
    public slug: MenuSlug,
    public payload: any,
  ) {
    super(MENU_NESTED, slug, payload);
  }
}

export class MenuNestedLoadSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_MENU_NESTED_SUCCESS;

  constructor(
    public slug: MenuSlug,
    public payload: MenuItemNested[],
  ) {
    super(MENU_NESTED, slug, payload);
  }
}

export class MenuNestedReset extends StateUtils.EntityLoaderResetAction {
  readonly type = MENU_NESTED_RESET;

  constructor(public slug: MenuSlug) {
    super(MENU_NESTED, slug);
  }
}

export type MenuNestedAction = MenuNestedLoad | MenuNestedLoadSuccess | MenuNestedLoadFail | MenuNestedReset;
